import React, {useEffect} from "react";
import {useRef} from "react";
import {MapContainer, Marker, Popup, TileLayer} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import useApiFetch from "./utils/api";
import {API_URL, markerCustom} from "./utils/constant";
import L from "leaflet";
import Sidebar from "./sidebar";

export default function Map() {
  const mapRef = useRef();

  let isMapSmall = document.querySelector("#carte-adherents").getAttribute("data-map-size");
  isMapSmall = !!isMapSmall;


  const {
    res: restData,
    load: loadData,
    loading: loadingData,
  } = useApiFetch("GET", API_URL + "/adherent");

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="map-container">
      <MapContainer
        center={[46.603354, 1.888334]}
        zoom={6}
        scrollWheelZoom={false}
        ref={mapRef}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {restData?.posts.map((item) => {
          return (
            <Marker
              key={item.id}
              position={[item.latitude, item.longitude]}
              icon={L.icon({
                iconUrl: markerCustom,
                iconSize: [45, 45],
              })}
              eventHandlers={{
                click: () => {
                  let map = mapRef.current;
                  map.flyTo([item.latitude, item.longitude], 6);
                },
              }}
            >
              <Popup>
                <div>
                  <h2>{item.post_title}</h2>
                  <p>{item.phone}</p>
                  <p>{item.email}</p>
                  <p>{item.address}</p>
                  <p>{item.website}</p>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
      {!isMapSmall &&
        <Sidebar mapRef={mapRef}/>
      }
    </div>
  );
}
